/**
 * DashboardScreen — overview cards.
 *
 * Stage 3.1: empty placeholders + welcome message. The real cards
 * (member count, pending payments, next event, recent audit events)
 * land alongside the screens that own that data in Stage 3.3.
 */
import { useAuth } from "../auth/AuthProvider";

export function DashboardScreen() {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <div className="rounded-lg border border-stone-200 bg-white p-6">
        <h2 className="text-lg font-semibold text-stone-900">
          Welcome{user?.firstName ? `, ${user.firstName}` : ""}.
        </h2>
        <p className="mt-1 text-sm text-stone-600">
          You're signed in as <span className="font-medium capitalize">{user?.role}</span>.
          Use the sidebar to navigate to the areas you can edit.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <Card title="Members" hint="Live count + recent signups land here in Stage 3.3a" />
        <Card title="Payments this month" hint="Treasurer summary lands in Stage 3.3b" />
        <Card title="Next event" hint="Flagship + upcoming lands in Stage 3.3d" />
      </div>
    </div>
  );
}

function Card({ title, hint }: { title: string; hint: string }) {
  return (
    <div className="rounded-lg border border-stone-200 bg-white p-5">
      <div className="text-xs font-medium uppercase tracking-wide text-stone-500">{title}</div>
      <div className="mt-2 text-2xl font-semibold text-stone-300">—</div>
      <div className="mt-2 text-xs text-stone-400">{hint}</div>
    </div>
  );
}
